import axios from "axios";
import * as Globals from "../Globals";
import { PostAlert } from "./AlertActions";
import { loadActiveLicenses } from "../state/licenseSlice";
export function GetActiveLicense(dispatch) {
  axios.get(`${Globals.baseUrl}/License/GetActiveLicense`, {
    headers: { "content-type": "application/json; charset=utf-8" }
  }).then((res) => {
    if (res.status === 200) {
      dispatch(loadActiveLicenses(res.data));
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
  });
}
export function GetLicenseSummary(dispatch) {
  console.log("Lic Summary");
  axios.get(`${Globals.baseUrl}/License/GetLicenseSummary`, {
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      console.log(res.data);
      dispatch(loadActiveLicenses(res.data));
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function UpdateLicense(file, licenseType, dispatch) {
  let fd = new FormData();
  fd.append("file", file, file.name);
  fd.append("LicenseType", licenseType);
  axios.post(`${Globals.baseUrl}/License/UpdateLicense`, fd, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      PostAlert("success", "License updated");
      dispatch(loadActiveLicenses(res.data));
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    } else if (res.status === 500) {
      PostAlert("error", "License failed to update");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function ExportLicenseAllocation(dispatch) {
  axios.get(`${Globals.baseUrl}/License/ExportLicenseAllocation`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    },
    responseType: "blob"
  }).then((res) => {
    if (res.status === 200) {
      var link = document.createElement("a");
      link.setAttribute("download", "");
      link.href = window.URL.createObjectURL(new Blob([res.data]));
      link.download = "TrinDocs License Allocation.xlsx";
      document.body.appendChild(link);
      link.click();
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
  });
}
